import { api } from '../config/base-api';

interface GetRegionsParams {
  country: string;
  brand: string;
  recurringSaleAllowed?: boolean;
}

export interface GetRegionsResponse {
  brand: string;
  country: string;
  region: string;
}

export async function getRegions({
  brand,
  country,
  recurringSaleAllowed,
}: GetRegionsParams): Promise<GetRegionsResponse[]> {
  const res = await api.get<GetRegionsResponse[]>(
    '/api/v1/franchises/regions',
    {
      params: {
        brand,
        country,
        ...(recurringSaleAllowed !== undefined && { recurringSaleAllowed }),
      },
    }
  );

  return res.data;
}
